<template>
  <div class="container">
    <!-- 新增图片展示框 -->
    <img 
      class="show-image"
      :src="imageUrl" 
      alt="展示图片"
    />
    <!-- 显示 IP 信息 -->
    <p class="scan-tip">请保存二维码或者长按扫一扫完成支付</p>
  </div>
</template>

<script>

export default {
  name: 'TestPage',
  data() {
    return {
      ipInfo: null,
      isFailed: false,
      imageUrl: ''  // 新增图片 URL 数据
    };
  },
  created() {
    // 从 URL 参数中获取图片 URL
    this.imageUrl = this.$route.query.src;
  },
  async mounted() {
    try {
      await this.getIpInfo();
    } catch (error) {
      console.error('获取 IP 信息失败:', error);
      this.isFailed = true;
    }
  },
  methods: {

  }
};
</script>

<style scoped>
.container {
  text-align: center; /* 让容器内的内联元素水平居中 */
  min-height: 100vh; /* 确保容器至少占满视口高度 */
  padding: 40px 20px; /* 添加内边距 */
  background-color: #f8f9fa; /* 浅灰色背景 */
  font-family: 'Microsoft YaHei', Arial, sans-serif; /* 商务风字体 */
}

.show-image {
  margin-top: 20px; /* 可根据实际需求调整与按钮的垂直间距 */
  display: block; /* 将图片转为块级元素 */
  margin-left: auto; /* 配合 margin-right 实现水平居中 */
  margin-right: auto; 
  max-width: 80%; /* 限制图片最大宽度 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加阴影 */
  border-radius: 8px; /* 圆角效果 */
}

.scan-tip {
  margin-top: 30px; /* 与上方图片保持 30px 间隔 */
  font-size: 18px; /* 增大字体大小 */
  color: #333; /* 深灰色文字 */
  font-weight: 500; /* 字体加粗 */
}
</style>